import React from "react";
import { Link } from "react-router-dom";
import brand from "../db/brand";
import services from "../db/services";

const Footer = () => (
  <footer className="foot">
    <div className="shell">
      <div className="grid">
        <div className="lead-block">
          <img src="/brand/ntac-logo.png" alt={brand.short} className="footer-logo" />
          <p>{brand.pitch}</p>
        </div>
        <div>
          <h5>Services</h5>
          {services.slice(0, 4).map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`}>{s.title}</Link>
          ))}
        </div>
        <div>
          <h5>More</h5>
          {services.slice(4).map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`}>{s.title}</Link>
          ))}
        </div>
        <div>
          <h5>Studio</h5>
          <Link to="/outcomes">Outcomes</Link>
          <Link to="/pulse">Pulse</Link>
          <Link to="/studio">About</Link>
          <Link to="/contact">Contact</Link>
          <a href={`mailto:${brand.contact.email}`}>{brand.contact.email}</a>
        </div>
      </div>
      <div className="colophon">
        <span>© {new Date().getFullYear()} {brand.legal}. All rights reserved.</span>
        <span>{brand.hq.city}, {brand.hq.country}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
